export default function valueGetter({
  data, // row from where value is being rendered
  // node, // node to be rendered
  colDef, // current column definition
  // api, // grid api
  // context, // grid context
  // getValue, // Function to get value
}) {
  const [group, child = false] = colDef.field.split('__');

  return {
    data,
    group,
    child,
    text: (typeof data[colDef.field] !== 'undefined') ?
      data[colDef.field] : '',
  };
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/services/table/valueGetter.js
 **/